<template>
  <div class="container">
    <div class="title">
      <span class="tips"
        ><i>{{ $t('person.letter.tips.tip1') }}</i
        >{{ $t('person.letter.tips.tip2') }}</span
      >
      <span class="tip">{{ $t('person.letter.tips.tip3') }}</span>
    </div>
    <div class="main">
      <div class="head">{{ info.title + form.name + ':' }}</div>
      <div class="tipInfo">
        <div class="tip1">{{ info.tip1 }}</div>
        <div class="tip1">{{ info.tip2 }}</div>
        <div class="tip2">{{ info.tip3 }}</div>
      </div>
      <div class="visitInfoRegister">
        <div class="button" :style="{ width: lang == 'zh' ? '132px' : '200px' }">{{ $t('person.letter.infos.info1') }}</div>
        <el-form :model="form">
          <el-form-item :label="$t('person.baseInfos.name')">
            {{ form.name }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.company')">
            {{ form.company }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.duty')">
            {{ form.duty }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.phone')">
            {{ form.registAccount }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.email')">
            {{ form.email }}
          </el-form-item>
          <!-- <el-form-item label="二维码：">
            <img :src="baseUrl + form.column23" alt="" />
          </el-form-item> -->
        </el-form>
      </div>
      <div class="loginInfo">
        <div class="button" :style="{ width: lang == 'zh' ? '132px' : '180px' }">{{ $t('person.letter.infos.info2') }}</div>
        <el-form :model="form">
          <el-form-item :label="$t('person.letter.registAccount')">
            {{ form.registAccount }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.password')">
            {{ form.cause }}
          </el-form-item>
        </el-form>
        <span class="littleTip"
          ><i>{{ $t('person.letter.tips.tip1') }}</i
          >{{ $t('person.letter.tips.tip4') }}</span
        >
      </div>
      <div class="visitInfo">
        <div class="button" :style="{ width: lang == 'zh' ? '132px' : '150px' }">{{ $t('person.letter.infos.info3') }}</div>
        <el-form :model="info">
          <el-form-item :label="$t('person.letter.time')">
            {{ info.time1 }}
            {{ info.time2 }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.address')">
            {{ info.address }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.position')">
            {{ info.position }}
          </el-form-item>
        </el-form>
        <div class="imgInfo">
          <span class="span1">{{ $t('person.letter.img') }}</span>
          <el-image style="width:230px; height: 180px" :src="img" :preview-src-list="srcList"> </el-image>
        </div>
      </div>
      <div class="consultInfo">
        <div class="button">{{ $t('person.letter.infos.info4') }}</div>
        <div class="companyName">{{ $t('person.letter.companyName') }}</div>
        <el-form :model="info">
          <el-form-item :label="$t('person.letter.contacts')">
            {{ info.linkPerson }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.telephone')">
            {{ info.phone }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.email')">
            {{ info.email }}
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getConfirmation } from '../../../../api/personInfo.js';
import { forMat } from '../../../../utils/common.js';
import img from '../../../static/boothAddress.jpg';
export default {
  data() {
    return {
      img: img,
      srcList: [img],
      baseUrl: forMat(),
      info: {
        title: this.$t('person.letter.informations.title'),
        tip1: this.$t('person.letter.informations.tip1'),
        tip2: this.$t('person.letter.informations.tip2'),
        tip3: this.$t('person.letter.informations.tip3'),
        time1: this.$t('person.letter.informations.time1'),
        time2: this.$t('person.letter.informations.time2'),
        address: this.$t('person.letter.informations.address'),
        position: this.$t('person.letter.informations.position'),
        linkPerson: this.$t('person.letter.informations.linkPerson'),
        phone: this.$t('person.letter.informations.phone'),
        email: this.$t('person.letter.informations.email'),
      },
      form: {
        name: '', //姓名
        company: '', //公司
        duty: '', //职位
        registAccount: '', //手机号
        email: '', //邮箱
        column23: '', //二维码
        cause: '', //密码
      },
      lang: '',
    };
  },
  created() {
    this.getInfo();
    this.lang = localStorage.getItem('lang');
  },
  methods: {
    async getInfo() {
      try {
        const { data } = await getConfirmation();
        if (data.code === 200) {
          this.form = data.data;
          // this.form.column23 = '/hz/userfiles/upload/image/20190823/p1diu1jauc163o1na713n2p9e88oh.JPG';
          // 测试数据 二维码
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
  watch: {
    lang(newValue, oldValue) {
      if (newValue == 'en') {
        this.lang = 'en';
      }
      if (newValue == 'zh') {
        this.lang = 'zh';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-bottom: 60px;
  box-sizing: border-box;
  .title {
    height: 42px;
    background: #f6f6f7;
    line-height: 42px;
    padding-left: 30px;
    box-sizing: border-box;
    .tips {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 22px;
      i {
        font-style: normal;
        margin-right: 5px;
      }
    }
    .tip {
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }
  }
  .main {
    margin-top: 30px;
    margin-left: 80px;
    .head {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    .tipInfo {
      margin-top: 30px;
      margin-left: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 24px;
      .tip1 {
        color: #333333;
      }
      .tip2 {
        color: #ff190c;
        margin-top: 20px;
      }
    }
    .visitInfoRegister {
      margin-top: 40px;
      margin-left: 40px;
      .button {
        text-align: center;
        // width: 132px;
        height: 24px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
      img {
        width: 100px;
        height: 100px;
        background: #d8d8d8;
      }
    }
    .loginInfo {
      margin-top: 52px;
      margin-left: 40px;
      .button {
        text-align: center;
        width: 132px;
        height: 24px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
      .littleTip {
        i {
          color: #ff190c;
          margin-right: 5px;
        }
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        line-height: 22px;
      }
    }
    .visitInfo {
      margin-top: 50px;
      margin-left: 40px;
      .button {
        text-align: center;
        width: 76px;
        height: 24px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
      .imgInfo {
        margin-top: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
        display: flex;
        .span1 {
          color: #333333;
          display: block;
        }
        .span2 {
          color: #006fb8;
          font-size: 16px;
        }
      }
    }
    .consultInfo {
      margin-top: 50px;
      margin-left: 40px;
      .button {
        text-align: center;
        width: 76px;
        height: 24px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
      .companyName {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 0px;
  height: 30px;
}
.el-form-item >>> .el-form-item__content {
  height: 30px;
  line-height: 30px;
}
.el-form-item >>> .el-form-item__label {
  padding: 0;
  line-height: 30px;
  height: 30px;
}
</style>
